import React from 'react'
import { Modal } from 'react-bootstrap';


export default function ChangeInstallationModal({
 pageLanguage,
 modals,
 modalHandleClose,
 t,
 setStep2,
 mountTypeTemp,
 setStep3,
 setStep21,
 setStep21Err1,
 setStep21Err3,
 setDeps,
 setCart,
 clearInputs
}) {
  return (
   <Modal
   dialogClassName={`warning_modal2 bigSizeModal ${
     pageLanguage === "fa" ? "font_farsi" : "font_en"
   }`}
   show={modals["MountTypeWarning"] === undefined ? false : modals["MountTypeWarning"]}
   onHide={() => modalHandleClose("MountTypeWarning")}
 >
   <Modal.Header>{/*<Modal.Title>Modal heading</Modal.Title>*/}</Modal.Header>
   <Modal.Body>
     <p>{t("MountTypeWarning")}</p>

     <br />
     <div className="buttons_section">
       <button
         className="btn btn-new-dark"
         onClick={() => {
           modalHandleClose("MountTypeWarning");
         }}
       >
         {pageLanguage === "en" ? "CANCEL" : "ادامه سفارش"}
       </button>
       <button
         className="btn white_btn"
         onClick={() => {
           setStep2(mountTypeTemp.stepValue);
           setStep3("");
           setStep21("");
           setStep21Err1(false);
           setStep21Err3(false);
           if (
             mountTypeTemp.stepValue === "Inside" ||
             mountTypeTemp.stepValue === "HiddenMoulding"
           ) {
             setDeps("3,21", "2,3AOut,3BOut1,3BOut2,3COut,3DOut,3CArc1,3CArc2,3CArc3");
           } else {
             setDeps("3", "2,21,3AOut,3BOut1,3BOut2,3COut,3DOut,3CArc1,3CArc2,3CArc3");
           }
           setCart(
             "Mount",
             mountTypeTemp.cartValue,
             "calcMeasurements,Width,Height,WidthCart,HeightCart,WindowWidth,WindowHeight,Width3A,Height3C,ExtensionLeft,ExtensionRight,ShadeMount,CeilingToWindow1,CeilingToWindow2,CeilingToWindow3"
           );
           clearInputs(mountTypeTemp.event, undefined, "3");
           modalHandleClose("MountTypeWarning");
         }}
       >
         {pageLanguage === "en" ? "I AGREE, CONTINUE ANYWAY" : "تغییر نحوه نصب"}
       </button>
     </div>
   </Modal.Body>
 </Modal>
  )
}
